import React from "react";
import { Row, Col } from "react-bootstrap";

import { SectionTitle } from "../components/SectionTitle";
import { AltFeatureItem } from "../components/AltFeatureItem";
import { SubSectionTitle } from "../components/SubSectionTitle";

import { FaMicrochip, FaWaveSquare, FaCogs, FaBolt, FaVideo, FaCheckCircle, FaProjectDiagram, FaSlidersH, FaHeartbeat, FaTools, FaSitemap, FaSatelliteDish, FaFighterJet, FaRandom, FaLock, FaShieldAlt, FaCube } from "react-icons/fa";

export class Capabilities extends React.Component {
    render() {
        return (
            <section id="capabilities">
                <div>
                    <SectionTitle title="Capabilities" />

                    {/* Digital Design & FPGA */}
                    <Row>
                        <SubSectionTitle title="Digital Design & FPGA" />
                        <Row>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="FPGA & RTL Design" icon={FaMicrochip} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="DSP & Modulation" icon={FaWaveSquare} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Custom IP Cores" icon={FaCogs} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="High-Speed Interfaces" icon={FaBolt} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Video Codecs (H.264/H.265)" icon={FaVideo} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Forward Error Correction" icon={FaCheckCircle} />
                            </Col>
                        </Row>
                    </Row>

                    {/* Hardware Design */}
                    <Row>
                        <SubSectionTitle title="Hardware Design" />
                        <Row>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="High-Speed PCB Design" icon={FaProjectDiagram} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Mixed-Signal Circuits" icon={FaSlidersH} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Signal Integrity Analysis" icon={FaHeartbeat} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Rapid Prototyping" icon={FaTools} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Schematic & Layout" icon={FaSitemap} />
                            </Col>
                        </Row>
                    </Row>

                    {/* Communication Solutions */}
                    <Row>
                        <SubSectionTitle title="Communication Solutions" />
                        <Row>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="UAV / USV Data Links" icon={FaSatelliteDish} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Air-to-Air Missile Links" icon={FaFighterJet} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="FHSS / DSSS Waveforms" icon={FaRandom} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="AES-256 & Custom Crypto" icon={FaLock} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Turbo / RS FEC" icon={FaShieldAlt} />
                            </Col>
                            <Col xs={6} xl={4}>
                                <AltFeatureItem title="Zynq & ZU+ SoMs" icon={FaCube} />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </section>
        );
    }
}
